import { render, staticRenderFns } from "./RightsHolderChallengeDetail.vue?vue&type=template&id=cb46b334&"
import script from "./RightsHolderChallengeDetail.vue?vue&type=script&lang=js&"
export * from "./RightsHolderChallengeDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports